<!-- close button -->
<button class="pos-absolute z-1 right-0 right-2-s top-2-s p-a cursor-pointer button-icon"
        type="button"
        (click)="close()"
        aria-label="Close modal window">
    <i class="fs-3 icon-close"
       aria-hidden="true"></i>
</button>

<div class="bg-col-w modal-body">
    <div class="flex">
        <!-- left side copy -->
        <div class="w-6 w-12-s center p-a p-a-6-s">
            <!-- modal contents -->
            <ng-content></ng-content>
        </div>

        <!-- right side image -->
        <div *ifSize="'!S'"
             class="w-6 pos-relative overflow-hidden">

            @if (sideImage) {
            <img class="fill"
                 [image]="sideImage">
            }
        </div>
    </div>
</div>